// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:600px){.imprint[data-v-48134207]{margin-top:35px}}@media only screen and (min-width:601px){.imprint[data-v-48134207]{margin-top:30px}}.text-grey[data-v-48134207]{color:#757575!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
